function initTextRotators() {
  const textRotators = document.querySelectorAll('.title-layer-2');
  let currentIndex = 0;

  // Change text every 3 seconds
  setInterval(() => {
    textRotators.forEach((textRotator, index) => {
      textRotator.classList.toggle('visible', index === currentIndex);
    });

    currentIndex = (currentIndex + 1) % textRotators.length;
  }, 2000);
}

function alignDesktopIngredientsWithCan() {
  const sections = document.querySelectorAll('.s2g-homepage-hero');

  sections.forEach(section => {
    const ingredientsWrapper = section.querySelector('.ingredients-image-wrapper');
    if (!ingredientsWrapper) return;

    if (window.innerWidth <= 992) {
      // Reset transform on mobile
      ingredientsWrapper.style.transform = '';
      return;
    }

    const canImage = section.querySelector('.hero-can-image');
    if (!canImage) return;

    // We need to wait for images to load before we can measure them properly
    const desktopImg = ingredientsWrapper.querySelector('.s2g-homepage-hero__ingredients-desktop');
    
    if (!canImage.complete || (desktopImg && !desktopImg.complete)) {
      if (!canImage.complete) canImage.addEventListener('load', alignDesktopIngredientsWithCan, { once: true });
      
      if (desktopImg && !desktopImg.complete) {
        desktopImg.addEventListener('load', alignDesktopIngredientsWithCan, { once: true });
      }
      return;
    }

    // Temporarily remove transform to get accurate base position
    ingredientsWrapper.style.transform = 'none';

    const canRect = canImage.getBoundingClientRect();
    const ingredientsRect = ingredientsWrapper.getBoundingClientRect();

    // Calculate the center points
    const canCenterX = canRect.left + canRect.width / 2;

    const ingredientsCenterX = ingredientsRect.left + ingredientsRect.width / 2;

    // Calculate the difference
    const diffX = canCenterX - ingredientsCenterX;

    // Apply the translation
    ingredientsWrapper.style.transform = `translate(${diffX}px)`;
  });
}

function positionIngredientChunks() {
  const sections = document.querySelectorAll('.s2g-homepage-hero');
  if (!sections.length) return;

  sections.forEach(section => {
    const chunkEls = section.querySelectorAll('.ingredient-chunk--wrapper');
    chunkEls.forEach(el => {
      const xAnchor = (el.dataset.xAnchor || 'left').toLowerCase();
      const yAnchor = (el.dataset.yAnchor || 'top').toLowerCase();

      const xOffsetRaw = el.dataset.xOffset;
      const yOffsetRaw = el.dataset.yOffset;

      const xOffsetNum = Number.parseFloat(xOffsetRaw);
      const yOffsetNum = Number.parseFloat(yOffsetRaw);

      const xOffset = Number.isFinite(xOffsetNum) ? `${xOffsetNum}%` : '0%';
      const yOffset = Number.isFinite(yOffsetNum) ? `${yOffsetNum}%` : '0%';

      if (xAnchor === 'right') {
        el.style.left = 'auto';
        el.style.right = xOffset;
      } else if (xAnchor === 'center') {
        el.style.right = 'auto';
        el.style.left = `calc(50% + ${xOffset})`;
      } else {
        el.style.right = 'auto';
        el.style.left = xOffset;
      }

      if (yAnchor === 'bottom') {
        el.style.top = 'auto';
        el.style.bottom = yOffset;
      } else if (yAnchor === 'center') {
        el.style.bottom = 'auto';
        el.style.top = `calc(50% + ${yOffset})`;
      } else {
        el.style.bottom = 'auto';
        el.style.top = yOffset;
      }
    });
  });
}

function initIngredientChunkFloaters() {
  const sections = document.querySelectorAll('.s2g-homepage-hero');
  if (!sections.length) return;

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) return;

  const floaters = [];

  sections.forEach(section => {
    const chunkEls = section.querySelectorAll('.ingredient-chunk--wrapper');
    chunkEls.forEach((el, index) => {
      const imgEl = el.querySelector('.ingredient-chunk--image');
      if (!imgEl) return;

      const speed = Number.parseFloat(el.dataset.speed);
      const xRange = Number.parseFloat(el.dataset.xRange);
      const yRange = Number.parseFloat(el.dataset.yRange);

      floaters.push({
        el,
        imgEl,
        section,
        index,
        speed: Number.isFinite(speed) ? speed : 1,
        xRange: Number.isFinite(xRange) ? xRange : 0,
        yRange: Number.isFinite(yRange) ? yRange : 0,
        seed: (index + 1) * 1000 + (floaters.length + 1) * 17,
        active: true
      });
    });
  });

  if (!floaters.length) return;

  let rafId = null;
  let isRunning = false;
  let lastNow = null;
  let t = 0;

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  const getSectionProgress = section => {
    const rect = section.getBoundingClientRect();
    const viewportH = window.innerHeight || document.documentElement.clientHeight || 1;
    const raw = (viewportH - rect.top) / (viewportH + rect.height);
    return clamp(raw, 0, 1);
  };

  const tick = now => {
    if (!isRunning) return;

    if (lastNow == null) lastNow = now;
    const dt = (now - lastNow) / 1000;
    lastNow = now;

    t += dt;

    for (const floater of floaters) {
      if (!floater.active) continue;

      const progress = getSectionProgress(floater.section);
      const baseSpeed = Math.max(0, floater.speed);
      const phase = t * baseSpeed + floater.seed;

      const floatX = Math.sin(phase) * floater.xRange;
      const floatY = Math.cos(phase * 0.9) * floater.yRange;

      const parallaxY = (progress - 0.5) * 2 * floater.yRange * 0.6;

      floater.imgEl.style.transform = `translate3d(${floatX}px, ${floatY + parallaxY}px, 0)`;
    }

    rafId = window.requestAnimationFrame(tick);
  };

  const start = () => {
    if (isRunning) return;
    isRunning = true;
    lastNow = null;
    rafId = window.requestAnimationFrame(tick);
  };

  const stop = () => {
    isRunning = false;
    if (rafId != null) window.cancelAnimationFrame(rafId);
    rafId = null;
  };

  const io = new IntersectionObserver(
    entries => {
      for (const entry of entries) {
        const hasActive = floaters.some(f => f.section === entry.target && f.active);
        if (!hasActive) continue;

        const inView = entry.isIntersecting;
        floaters.forEach(f => {
          if (f.section === entry.target) f.active = inView;
        });
      }

      const anyActive = floaters.some(f => f.active);
      if (anyActive) start();
      else stop();
    },
    { threshold: 0 }
  );

  sections.forEach(section => io.observe(section));

  const handleVisibility = () => {
    if (document.visibilityState === 'hidden') stop();
    else if (floaters.some(f => f.active)) start();
  };

  document.addEventListener('visibilitychange', handleVisibility);

  start();
}

function hydrateHomepageHero() {
  initTextRotators();
  alignDesktopIngredientsWithCan();
  positionIngredientChunks();
  initIngredientChunkFloaters();
  
  // Re-align on resize
  window.addEventListener('resize', alignDesktopIngredientsWithCan);
  window.addEventListener('resize', positionIngredientChunks);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateHomepageHero);
} else {
  hydrateHomepageHero();
}
